import React from 'react';
import EntitiesErrorMessages from '@/components/errors/EntitiesErrorMessages';
import HoverActionHeader from '@/components/HoverActionHeader';
import selectors from '../hooks/selectors';
import events from '../hooks/events';
import DatasetAdminAccordion from '../components/DatasetAdminAccordion';
import DatasetAdminGrid from '../components/DatasetAdminGrid';
import DatasetAdminPanelContainer from '../components/DatasetAdminPanelContainer';

const DatasetSettings = ({
  category,
  code,
  compact,
  title,
}) => {
  const state = selectors.useDatasetSettings({ category, code });
  const updateProperties = events.useUpdateDatasetSettingsProperties(category, { code });
  return (
    <div className="aridhia-dataset-settings aridhia-wizard-content">
      <HoverActionHeader value={title} icon="table" className="aridhia-catalogue-list-header" />
      <DatasetAdminPanelContainer
        canRead={state.canRead}
        category={category}
        code={code}
        exists={state.exists}
        readErrors={state.readErrors}
        readStatus={state.readStatus}
      >
        {compact && (
        <>
          <EntitiesErrorMessages
            category={category}
            code={code}
            entity="dataset-settings"
            errors={state.saveErrors}
            onDismiss={(errors) => updateProperties({ properties: { saveErrors: errors } })}
          />
          <DatasetAdminAccordion
            category={category}
            code={code}
            hideCatalogue
            hideMetrics
            name={title}
            panels={state.panels}
          />
        </>
        )}
        {!compact && (
        <DatasetAdminGrid
          category={category}
          code={code}
          hideCatalogue
          hideMetrics
          name={title}
          panels={state.panels}
          saveErrors={state.saveErrors}
          datasourceSupportsCohort={state.datasourceSupportsCohort}
        />
        )}
      </DatasetAdminPanelContainer>
    </div>
  );
};

export default DatasetSettings;
